import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

interface GlobalDialogData {
  title: string
  content: string
  showConfirmButton?: boolean
}

export const useGlobalDialogStore = defineStore('global-dialog', () => {
  const _isDialogShow = ref(false)

  const _globalDialogData = ref<GlobalDialogData | null>(null)

  const _ifConfirm = ref<((value: boolean) => void) | null>(null)

  const globalDialogData = computed(() => {
    return _globalDialogData.value
  })

  const isDialogShow = computed(() => {
    return _isDialogShow.value
  })

  /** 顯示 API 錯誤訊息 */
  const openGlobalDialog = (data: GlobalDialogData) => {
    _globalDialogData.value = data
    _isDialogShow.value = true
  }

  /** 顯示需要確認的對話框 */
  const openConfirmDialog = (data: GlobalDialogData): Promise<boolean> => {
    return new Promise((ifConfirm) => {
      _globalDialogData.value = {
        ...data,
        showConfirmButton: true
      }
      _isDialogShow.value = true
      _ifConfirm.value = ifConfirm
    })
  }

  const closeGlobalDialog = () => {
    _ifConfirm.value?.(false)
    _globalDialogData.value = null
    _isDialogShow.value = false
    _ifConfirm.value = null
  }

  const confirmDialog = () => {
    const ifConfirm = _ifConfirm.value
    _ifConfirm.value = null
    closeGlobalDialog()
    ifConfirm?.(true)
  }

  const cancelDialog = () => {
    closeGlobalDialog()
  }

  return {
    globalDialogData,
    isDialogShow,
    openGlobalDialog,
    openConfirmDialog,
    closeGlobalDialog,
    confirmDialog,
    cancelDialog
  }
})
